import { load } from 'recaptcha-v3';

const getTokenCaptchaV3 = async (siteKey: string) => {
  const recaptcha = await load(siteKey);
  return recaptcha.execute('validate_captcha');
};

export { getTokenCaptchaV3 };
